var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDesktopSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.375 8h-5.25C52.504 8 52 8.504 52 9.125v9.75c0 .621.504 1.125 1.125 1.125h5.25c.621 0 1.125-.504 1.125-1.125v-9.75C59.5 8.504 58.996 8 58.375 8zM55.75 19.25a.75.75 0 11-.001-1.499.75.75 0 01.001 1.499zm2.625-2.531a.282.282 0 01-.281.281h-4.688a.282.282 0 01-.281-.281V9.406c0-.154.127-.281.281-.281h4.688c.154 0 .281.127.281.281v7.313z",
    fill: "#8092AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1v26",
    stroke: "#D2DDEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 18.2h-3A1.2 1.2 0 0113 17V9.2c0-.66.54-1.2 1.2-1.2h9.6A1.2 1.2 0 0125 9.2V17a1.2 1.2 0 01-1.2 1.2h-3l2.4 1.2v.6h-8.4v-.6l2.4-1.2zm-3-9v6.6h9.6V9.2h-9.6z",
    fill: "#4D72FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "desktop-selected_svg__clip0_392_5486"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(52 8)",
    d: "M0 0h7.5v12H0z"
  })))));
}

export default SvgDesktopSelected;